import React from 'react';
import { Modal, Typography, Space, Alert } from 'antd';
import { CheckCircleOutlined, InfoOutlined } from '@mui/icons-material';
import { PrimaryButton, OutlineButton } from '../../Components/Buttons/Buttons';
import { getTheme } from '../../../theme/theme';

const { Title, Paragraph } = Typography;

/**
 * Modal for confirming quote acceptance
 * @param {Object} props - Component properties
 * @param {boolean} props.visible - Whether the modal is visible
 * @param {Function} props.onConfirm - Function called when acceptance is confirmed
 * @param {Function} props.onCancel - Function called when modal is cancelled
 * @param {Object} props.order - Order object containing quote information
 */
const QuoteAcceptModal = ({
    visible,
    onConfirm,
    onCancel,
    order
}) => {
    const theme = getTheme();

    return (
        <Modal
            title={
                <Space align="center">
                    <CheckCircleOutlined style={{ color: theme.token.colorSuccess }} />
                    <Title level={4} style={{ margin: 0, color: theme.token.colorText }}>
                        Confirm Quote Acceptance
                    </Title>
                </Space>
            }
            open={visible}
            onCancel={onCancel}
            footer={null}
            width={500}
            centered
            style={{
                borderRadius: '12px',
            }}
            styles={{
                body: {
                    padding: '24px',
                    backgroundColor: theme.token.colorBgContainer,
                }
            }}
        >
            <Space direction="vertical" size="large" style={{ width: '100%' }}>
                {/* Information Alert */}
                <Alert
                    message="Quote Acceptance Confirmation"
                    description="By accepting this quote, you are agreeing to proceed with the order under the terms and conditions specified in the quote document."
                    type="info"
                    icon={<InfoOutlined />}
                    showIcon
                    style={{
                        backgroundColor: theme.token.colorInfoBg,
                        borderColor: theme.token.colorInfo,
                    }}
                />

                {/* Confirmation Message */}
                <div>
                    <Paragraph style={{ color: theme.token.colorTextSecondary, textAlign: 'center' }}>
                        Are you sure you want to accept this quote? This action will proceed with
                        the order and cannot be undone.
                    </Paragraph>
                </div>

                {/* Action Buttons */}
                <Space size="middle" style={{ width: '100%', justifyContent: 'center', marginTop: '16px' }}>
                    <OutlineButton
                        onClick={onCancel}
                        style={{ minWidth: '120px' }}
                    >
                        Cancel
                    </OutlineButton>
                    <PrimaryButton
                        icon={<CheckCircleOutlined />}
                        onClick={onConfirm}
                        style={{ minWidth: '120px' }}
                    >
                        Accept Quote
                    </PrimaryButton>
                </Space>
            </Space>
        </Modal>
    );
};

export default QuoteAcceptModal; 